<template>
  <div v-if="popupVisible" class="view-details-popup">
    <div class="game-detail-testers">
      <div class="title-header">
        <button class="exit-button" @click="close_window()"></button>
        <h2>{{ gameName }}</h2>
        <button class="help-button" @click="openHelp(true)"></button>
      </div>

      <div class="game-summary">
        <div class="image-container">
          <img class="game-image" v-if="gameImg !== ''" :src="gameImg" />
          <img class="game-image-backup" v-else src="../../assets/Not Found.png" />
        </div>
        <div class="game-info">
          <div class="game-description" id="onboarding-description">
            <span class="description-label">Description:</span>
            <p class="game-description-text">{{ gameDescription || 'No description available.' }}</p>
          </div>
        </div>
      </div>

      <div class="action-sections">
        <div class="section-card playtest-section" id="onboarding-playtest-session">
          <div class="section-header">
            <h3 class="section-title">Playtest Session</h3>
          </div>
          <div class="section-content">
            <select v-model="selectedPlayPeriod" id="playperiod-dropdown" class="playperiod-select" @change="onPlayPeriodChange">
              <option disabled value="">Select a session</option>
              <option v-for="playPeriod in playPeriods" :key="playPeriod" :value="playPeriod">
                {{ playPeriod }}
              </option>
            </select>
          </div>
        </div>

        <div class="section-card actions-section">
          <div class="section-header">
            <h3 class="section-title">Quick Actions</h3>
          </div>
          <div class="section-content">
            <div class="action-buttons" id="onboarding-quick-actions">
              <button 
                id="onboarding-saved-sessions"
                class="action-button saved-session" 
                :disabled="!playPeriodExists" 
                @click="load_playtest()"
              >
                <img class="button-icon" src="../../assets/past-sessions.png" />
                <span>Saved Session</span>
              </button>

              <button 
                class="action-button surveys" 
                :disabled="!hasSurveys" 
                @click="goToSurveys()"
              >
                <svg class="button-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <span>View Surveys</span>
              </button>
            </div>
          </div>
        </div>

        <div class="section-card download-section" id="onboarding-download">
          <div class="section-header">
            <h3 class="section-title">Game Download</h3>
          </div>
          <div class="section-content">
            <div class="download-info">
              <span class="download-text">
  {{ downloadLink ? 'Build ready for download' : 'Download available after selecting a period' }}
</span>
              <button :disabled="!downloadLink" class="download-button" @click="downloadBuild">
                <svg class="download-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4m4-5l3 3 3-3m-3-3v12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="main-action">
        <button 
          id="onboarding-start-playtest"
          :disabled="selectedPlayPeriod === ''" 
          class="start-playtest-button" 
          @click="start_playtest()"
        >
          <svg class="play-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8 5v14l11-7z" fill="currentColor"/>
          </svg>
          Start New Playtest
        </button>
      </div>
    </div>

    <div class="popup-backdrop" @click="close_window()"></div>
  </div>
</template>

<script>
import PlayTesterUser from "../../Firestore/PlayTesterUser";
import GameTesting from "../../Firestore/GameTesting";
import Response from "../../Firestore/Response";
import { onboardingService } from "@/services/OnboardingService";

export default {
    name: "GameDetailTesters",
    props: {
        popupVisible: Boolean
    },
    data() {
        return {
            userType: -1,
            gameId: "",
            gameName: "",
            gameImg: "",
            gameDescription: "",
            testerId: "",
            downloadLink: "",
            playPeriodExists: false,
            selectedPlayPeriod: '',
            playPeriods: [],
            playPeriodsInfo: {},
            hasSurveys: false
        }
    },
    //removed watcher method as it created duplicate items in array
    mounted() {
        this.testerId = window.localStorage.getItem('userId');
        this.userType = parseInt(window.localStorage.getItem("userType")) || -1;
        if (this.popupVisible) this.updatePopup();
    },
    methods: {
        close_window() {
            onboardingService.skip();
            this.selectedPlayPeriod = '';
            this.$emit('close');
        },
        goToSurveys() {
            if (!this.hasSurveys) return;
            window.localStorage.setItem('gameId', this.gameId);
            window.localStorage.setItem('gameName', this.gameName);
            this.close_window();
            this.$router.push({ name: 'project-surveys' });
        },
        checkForSurveys() {
            Response.getUnfinishedSurveysByTesterProject(this.testerId, this.gameId)
                .then(res => {
                    this.hasSurveys = res.data && res.data.length > 0;
                })
                .catch(() => { this.hasSurveys = false; });
        },
        start_playtest() {
            let playPeriodInfo = this.playPeriodsInfo[this.selectedPlayPeriod];
            if (!playPeriodInfo) return;
            window.localStorage.setItem('playPeriodID', playPeriodInfo.id);   //store IDlocally
            GameTesting.createTestSession(this.gameId, this.testerId, playPeriodInfo.id).then(() => {
                this.$router.push({ name: 'playtest' });
            });
        },
        load_playtest() {
            let playPeriodInfo = this.playPeriodsInfo[this.selectedPlayPeriod];
            GameTesting.loadTestSession(this.gameId, this.testerId, playPeriodInfo.id)
              .then(() => {this.$router.push({ name: 'playtest' }); });
        },
        downloadBuild() {
          if (!this.downloadLink) return;

          window.open(this.downloadLink, "_blank");
        },
        openHelp(force = false) {
            onboardingService.registerPageOnboarding('GameDetails', [
                {
                    selector: '#onboarding-description',
                    title: 'Description',
                    message: 'View all information regarding the current game project.',
                    position: 'bottom'
                },
                {
                    selector: '#onboarding-playtest-session',
                    title: 'Playtest Sessions',
                    message: 'Select an available time slot to participate in testing.',
                    position: 'bottom'
                },
                {
                    selector: '#onboarding-quick-actions',
                    title: 'Quick Actions',
                    message: 'Access your previous sessions or complete project surveys here.',
                    position: 'top'
                },
                {
                    selector: '#onboarding-download',
                    title: 'Download Client',
                    message: 'Download the specific game build for your selected session.',
                    position: 'top'
                },
                {
                    selector: '#onboarding-start-playtest',
                    title: 'Begin Testing',
                    message: 'Click here to initialize your playtest environment.',
                    position: 'top'
                }
            ]);
            
            setTimeout(() => {
                onboardingService.startPageOnboarding('GameDetails', this.testerId, force);
            }, 150);
        },
        updatePopup() {
    this.gameId = window.localStorage.getItem('gameId');
    this.gameName = window.localStorage.getItem('gameName');
    this.gameImg = window.localStorage.getItem('gameImg');

    console.log("=== UPDATE POPUP ===");
    console.log("gameId:", this.gameId);
    console.log("testerId:", this.testerId);

    PlayTesterUser.getPlayTesterProfile(this.testerId).then(res => {
        if (res.data["firstTimeUser"] && res.data["firstTimeUser"][0] === 1) {
            this.openHelp(false);
            PlayTesterUser.updateTesterFirstTime(this.testerId, 0);
        }
    });

    this.playPeriods = [];
    this.playPeriodsInfo = {};

    GameTesting.getPlaytesterSessions(this.gameId, this.testerId)
        .then(res => {
            console.log("=== PLAYTEST SESSIONS RETURNED ===");
            console.log(res.data);

            res.data.forEach(playPeriod => {
                console.log("PLAY PERIOD:", playPeriod);
                console.log("LINK FIELD:", playPeriod.link);

                //logic for not showing playtests until it is within the start and end date, works correctly
                //  const currDate = new Date().toISOString().split('T')[0];//this is formatted in UTC
                //  if (playPeriod.startTime <= currDate && currDate < playPeriod.endTime){

                this.playPeriods.push(playPeriod.name);
                this.playPeriodsInfo[playPeriod.name] = playPeriod;
                //  }else {
                //    console.log(playPeriod.startTime < currDate && currDate < playPeriod.endTime);
                //  }
            });

            console.log("playPeriodsInfo:", this.playPeriodsInfo);
        })
        .catch(err => {
            console.error("getPlaytesterSessions failed:", err);
        });

    this.checkForSurveys();
},
        onPlayPeriodChange() {
    console.log("=== PLAY PERIOD CHANGED ===");
    console.log("selectedPlayPeriod:", this.selectedPlayPeriod);

    let playPeriodInfo = this.playPeriodsInfo[this.selectedPlayPeriod];

    console.log("playPeriodInfo:", playPeriodInfo);

    if (!playPeriodInfo) {
        console.warn("No playPeriodInfo found");
        this.downloadLink = "";
        return;
    }

    console.log("playPeriodInfo.link:", playPeriodInfo.link);

    this.downloadLink = playPeriodInfo.link || "";

    console.log("downloadLink:", this.downloadLink);

    GameTesting.loadTestSession(this.gameId, this.testerId, playPeriodInfo.id)
        .then(res => {
            this.playPeriodExists =
                res.data &&
                res.data.length > 0 &&
                res.data[0].status === 'Active';

            console.log("playPeriodExists:", this.playPeriodExists);
        })
        .catch(err => {
            console.error(err);
            this.playPeriodExists = false;
        });
}
    }
}
</script>

<style scoped>
.view-details-popup {
  position: fixed;
  top: 0; left: 0;
  width: 100vw; height: 100vh;
  display: flex; align-items: center; justify-content: center;
  z-index: 999;
  animation: fadeIn 0.25s ease;
}

@keyframes fadeIn {
  from { opacity: 0; transform: scale(0.97); }
  to { opacity: 1; transform: scale(1); }
}

.popup-backdrop {
  position: fixed;
  top: 0; left: 0;
  width: 100vw; height: 100vh;
  background-color: rgba(15, 15, 15, 0.55);
  backdrop-filter: blur(6px);
  z-index: 998;
}

.game-detail-testers {
  background-color: #ffffff;
  position: relative;
  display: flex; flex-direction: column;
  width: 720px; max-height: 90vh;
  border-radius: 16px;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.25);
  overflow-y: auto;
  z-index: 999;
  padding-bottom: 20px;
}

.title-header {
  background: linear-gradient(135deg, #ff7a1f, #ff9857);
  display: flex; justify-content: center; align-items: center;
  min-height: 72px; width: 100%;
  border-radius: 16px 16px 0 0; padding: 0 24px;
}

.title-header h2 {
  color: #ff7a1f; background-color: rgba(255, 255, 255, 0.95);
  font-weight: 700; flex-grow: 1;
  padding: 10px 20px; margin: 0; border-radius: 10px;
  text-align: center; font-size: 1.5rem;
}

.exit-button, .help-button {
  background-size: cover; border: none;
  width: 36px; height: 36px; border-radius: 50%;
  cursor: pointer; transition: transform 0.2s ease;
}
.exit-button { background-image: url("../../assets/exit.png"); margin-right: 16px; }
.help-button { background-image: url("../../assets/help.png"); margin-left: 16px; }
.exit-button:hover, .help-button:hover { transform: scale(1.1); }

.game-summary {
  display: flex; background-color: #fafafa;
  margin: 24px; border-radius: 14px; padding: 20px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.08); gap: 20px;
}

.image-container { width: 120px; height: 120px; flex-shrink: 0; border-radius: 12px; overflow: hidden; background-color: #f0f0f0; }
.game-image { width: 100%; height: 100%; object-fit: cover; }

.game-description-text {
  margin: 6px 0 0 0; color: #444; padding: 12px 14px;
}

.action-sections { display: flex; flex-direction: column; gap: 18px; margin: 0 24px; }
.section-card { background: #ffffff; border-radius: 12px; padding: 18px; border: 1px solid #efefef; }
.section-title { color: #ff7a1f; font-size: 1rem; font-weight: 600; margin-bottom: 8px; }

.playperiod-select { width: 100%; padding: 10px; border-radius: 8px; border: 1.5px solid #e2e2e2; }

.action-buttons { display: flex; gap: 10px; }
.action-button {
  flex: 1; display: flex; align-items: center; justify-content: center; gap: 8px;
  padding: 12px; border: none; border-radius: 10px; font-weight: 600; cursor: pointer; color: white;
}

.saved-session { background-color: #17a2b8; }
.surveys { background-color: #ff7a1f; }

.action-button:disabled {
  background-color: #D7CBC5 !important;
  cursor: not-allowed;
  opacity: 0.8;
}

.download-info { display: flex; align-items: center; justify-content: space-between; gap: 10px; }
.download-button {
  width: 40px; height: 40px; border: none; border-radius: 50%; background: #ff7a1f;
  display: flex; align-items: center; justify-content: center; cursor: pointer;
}
.download-button:disabled { background-color: #D7CBC5; cursor: not-allowed; }

.main-action { display: flex; justify-content: center; margin: 24px; }
.start-playtest-button {
  background: linear-gradient(135deg, #ff7a1f, #ff9857);
  color: #fff; border: none; padding: 16px 40px; border-radius: 12px;
  font-weight: 700; cursor: pointer; display: flex; gap: 10px; align-items: center;
}
.start-playtest-button:disabled { background: #D7CBC5; cursor: not-allowed;}

.button-icon { width: 18px; height: 18px; }
</style>


// WEBPACK FOOTER //
// src/components/game-detail/GameDetail-TestersPopup.vue